import ForceSSRLink from "@/components/other/ForceSSRLink";
import styled from "styled-components";
import {getColor} from "@/styles/ThemeConfig";

// Styled Components
const Container = styled.div`
  text-align: center;
  padding: 200px 0;
`;

const Title = styled.h1`
  font-size: 3em;
  text-transform: uppercase;
  font-family: 'Josefin Sans',sans-serif;
  margin-bottom: 1rem;
  color: rgb(73, 73, 73);

  span {
    color: rgb(148, 148, 148);
    font-size: 0.8em;
  }
`;

const Message = styled.p`
  font-family:  'Josefin Sans',sans-serif;
  font-size: 1.2em;
  color: rgb(73, 73, 73);

  a {
  font-family:  'Josefin Sans',sans-serif;
      font-size: 1.2em;
    color: ${getColor('gold')};
    text-decoration: none;
  }
`;

export default function WrongPageSection()
{
    return <Container>
        <Title>
            Sorry wrong page
            <br/>
            <span>Error 404</span>
        </Title>
        <Message>
            <ForceSSRLink href="/">Click here</ForceSSRLink> to go to our homepage for more information.
        </Message>
    </Container>
}
